import { useEffect, useRef } from 'react';

export default function SuccessConfetti({ fire }) {
  const confettiRef = useRef(null);

  useEffect(() => {
    let cleanup = () => { };

    (async () => {
      if (!fire) return;

      try {
        // Evitar SSR: importa dinámico en cliente
        const mod = await import('canvas-confetti');
        const confetti = mod.default;

        // Canvas dedicado a pantalla completa (mejor perf)
        const canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.width = '100vw';
        canvas.style.height = '100vh';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = '9999';
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        document.body.appendChild(canvas);

        const myConfetti = confetti.create(canvas, { resize: true, useWorker: true });
        confettiRef.current = myConfetti;

        // Manejador de redimensionamiento
        const handleResize = () => {
          canvas.width = window.innerWidth;
          canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', handleResize);

        // Tiro principal
        myConfetti({
          particleCount: 140,
          spread: 70,
          startVelocity: 45,
          origin: { y: 0.6 }
        });

        // Animación de 1.5s con bursts aleatorios
        const duration = 1500;
        const end = Date.now() + duration;

        (function frame() {
          myConfetti({
            particleCount: 3,
            startVelocity: 30,
            spread: 360,
            ticks: 60,
            scalar: 1.1,
            origin: {
              x: Math.random(),
              y: Math.random() * 0.4 + 0.1
            }
          });
          if (Date.now() < end) requestAnimationFrame(frame);
        })();

        cleanup = () => {
          canvas.remove();
        };
      } catch (error) {
        console.error('Error al cargar canvas-confetti:', error);
      }
    })();

    return () => cleanup();
  }, [fire]);

  return null;
}
